export const CHECKOUT_FEE_KEYS = [
    "pkwday",
    "four",
    "womo",
    "caravan",
    "pkwnight",
    "kurtaxe_only",
] as const;

export type CheckoutFeeKey = (typeof CHECKOUT_FEE_KEYS)[number];

export type CheckoutPaymentFees = {
    defaultCents: number;
    byCheckout: Record<CheckoutFeeKey, number>;
};

export const DEFAULT_CHECKOUT_PAYMENT_FEES: CheckoutPaymentFees = {
    defaultCents: 200,
    byCheckout: {
        pkwday: 200,
        four: 200,
        womo: 200,
        caravan: 200,
        pkwnight: 200,
        kurtaxe_only: 0,
    },
};

function normalizeCents(value: unknown, fallback: number): number {
    if (typeof value !== "number" || !Number.isFinite(value) || value < 0) {
        return fallback;
    }
    return Math.round(value);
}

export function normalizeCheckoutPaymentFees(value: unknown): CheckoutPaymentFees {
    const input = (value && typeof value === "object" ? value : {}) as Partial<CheckoutPaymentFees>;
    const inputByCheckout = (input.byCheckout && typeof input.byCheckout === "object"
        ? input.byCheckout
        : {}) as Partial<Record<CheckoutFeeKey, number>>;

    const normalizedByCheckout = CHECKOUT_FEE_KEYS.reduce((acc, key) => {
        acc[key] = normalizeCents(inputByCheckout[key], DEFAULT_CHECKOUT_PAYMENT_FEES.byCheckout[key]);
        return acc;
    }, {} as Record<CheckoutFeeKey, number>);

    return {
        defaultCents: normalizeCents(input.defaultCents, DEFAULT_CHECKOUT_PAYMENT_FEES.defaultCents),
        byCheckout: normalizedByCheckout,
    };
}

export function isCheckoutFeeKey(value: string): value is CheckoutFeeKey {
    return (CHECKOUT_FEE_KEYS as readonly string[]).includes(value);
}

export function resolveCheckoutPaymentFeeCents(
    fees: CheckoutPaymentFees,
    checkoutKey?: string | null
): number {
    if (checkoutKey && isCheckoutFeeKey(checkoutKey)) {
        return fees.byCheckout[checkoutKey];
    }
    return fees.defaultCents;
}
